// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import * as moment from "moment";

class DateFormat {
  standardDate(date: Date): string {
    return moment
      .default(date)
      .format("DD/MM/YYYY à HH:mm")
      .replace(":", "h");
  }
}

export default new DateFormat();
